/** Updates the known set of voice agents (mirrored from room metadata). */
export const SET_VOICE_AGENTS = 'SET_VOICE_AGENTS';
/** Records the local participant's consent decision for receiving a voice agent's media. */
export const SET_VOICE_AGENT_CONSENT = 'SET_VOICE_AGENT_CONSENT';
/** Saves (or forgets) the mute state from before a consent request muted the local participant. */
export const SET_VOICE_AGENT_CONSENT_MUTE = 'SET_VOICE_AGENT_CONSENT_MUTE';
